export const GTM_ID = {
    NOTIFICATIONS: "features-calendar-configuration-notifications",
    CONFIGURATION_APPLY: "features-calendar-configuration-apply",
    CONFIGURATION_CLOSE: "features-calendar-configuration-close",
    CONFIGURATION_PUSH_SELECT: (eventDateId, checked) =>
        checked ? `features-calendar-configuration-select-${eventDateId}` : `features-calendar-configuration-unselect-${eventDateId}`,
};
export const GA4EVENT = {
    NAMES: { FEATURES_CALENDAR: "features-calendar" },
    ELEMENTS: {
        NOTIFICATIONS: "configuration-notifications",
        CONFIGURATION_APPLY: "configuration-apply",
        CONFIGURATION_CLOSE: "configuration-close",
        CONFIGURATION_PUSH_SELECT: (checked) =>
        checked ? `configuration-select` : `configuration-unselect`,
    }
};
